import { apply, call, put, select } from 'redux-saga/effects'

import VALUE from 'core/data-model/constants/values'
import { getDistributorGroupsFailed, getDistributorGroupsSuccess } from 'identity/actions'
import { getDistributorGroups, getDistributorGroupsStatus } from 'identity/selectors'
import {
  getModelFactorsFailed,
  getModelFactorsSuccess,
  getOccupationFactorsFailed,
  getOccupationFactorsSuccess,
  getOccupationsFailed,
  getOccupationsSuccess,
  getRidersFailed,
  getRidersSuccess,
  setFnaConfiguration,
  setViewConfiguration,
} from 'quick-quote/actions'
import { getToggles } from 'quick-quote/feature-toggles'
import { getOccupations, getOccupationsStatus } from 'quick-quote/insured-information/selectors'
import {
  getModelFactors,
  getModelFactorsStatus,
  getRiders,
  getRidersStatus,
} from 'quick-quote/product-common/coverage-plan/selectors'
import { getDisplayProducts, getDisplayProductsStatus } from 'quick-quote/product-selection/selectors'

/**
 * onGetProductsRequest
 * @param displayProductService {ReturnType<import('core/service/display-product/display-product').createDisplayProductService>}
 */
export function* onGetProductsRequest(displayProductService) {
  const products = yield call(displayProductService.listDisplayProducts)
  const {
    SHOW_LOAN_PRODUCT,
    SHOW_SPUL,
    SHOW_PRODUCT_ICARE,
    SHOW_PRODUCT_25PL,
    SHOW_PRODUCT_5WL85,
    SHOW_PRODUCT_IGROW,
    SHOW_PRODUCT_25P15,
    SHOW_PRODUCT_20P10,
    SHOW_PRODUCT_FLEXI_HEALTH,
    SHOW_PRODUCT_25P15S,
    SHOW_PRODUCT_20P10S,
    SHOW_PRODUCT_W85P10J,
    SHOW_PRODUCT_W85P10S,
    SHOW_PRODUCT_WL88J,
    SHOW_PRODUCT_WL88S,
    SHOW_PRODUCT_IRETIRE_R01,
    SHOW_PRODUCT_IRETIRE_R05,
    SHOW_PRODUCT_LR05,
    SHOW_PRODUCT_PERFECT_LIFE_SOLUTION,
    SHOW_PRODUCT_HEALTH_TOPPING,
    SHOW_PRODUCT_IPROTECT_10,
    SHOW_PRODUCT_12PL,
    SHOW_PRODUCT_SUKHAPABDEKDEE,
    SHOW_PRODUCT_PLB05,
    SHOW_PRODUCT_PLB10,
    SHOW_PRODUCT_PLB12,
    SHOW_PRODUCT_PLB15,
    SHOW_PRODUCT_RPUDR,
    SHOW_PRODUCT_IHEALTHY_ULTRA,
    SHOW_PRODUCT_CIWLM39,
    SHOW_PRODUCT_CIWLM50,
    SHOW_PRODUCT_CIWLM60,
    SHOW_PRODUCT_CIWLS39,
    SHOW_PRODUCT_CIWLS50,
    SHOW_PRODUCT_CIWLS65,
    SHOW_PRODUCT_LIFEREADY,
    SHOW_PRODUCT_LIFEREADY_CAMPAIGN,
    SHOW_PRODUCT_BUMNAN_READY,
    SHOW_PRODUCT_ULTIMATE_GROWTH,
    SHOW_PRODUCT_LIFE_SUPER_SAVE_14_5,
    SHOW_PRODUCT_MRTA,
    SHOW_PRODUCT_GLTSP,
    SHOW_PRODUCT_CANCERX5,
    SHOW_PRODUCT_KOOMVER_RETIRE,
    SHOW_PRODUCT_KOOMVER_COVER,
    SHOW_PRODUCT_KOOMVER_COMPENSATE,
    SHOW_PRODUCT_ROKE_RAI_SO_SHIELD,
    SHOW_PRODUCT_ISMART_80_6,
    SHOW_PRODUCT_LIFETREASURE,
    SHOW_PRODUCT_PA,
    SHOW_PRODUCT_LIFE_ULTRA_SAVE_10_3,
    SHOW_PRODUCT_GLOBAL_INDEX_16_6,
    SHOW_PRODUCT_INDEX_LINKED_25_5,
    SHOW_PRODUCT_INDEX_LINKED_15_8,
    SHOW_PRODUCT_KOOMVER_SOSHIELD,
    SHOW_PRODUCT_LIFEREADY_SIO,
    SHOW_PRODUCT_ISHIELD_SIO,
    SHOW_PRODUCT_12PL_SIO,
    SHOW_PRODUCT_CI_COMBO,
    SHOW_PRODUCT_HEALTH_COMBO,
    SHOW_PRODUCT_KOOMVER_ROKE_RAI,
  } = yield call(getToggles)
  return products
    .filter((product) => SHOW_PRODUCT_25PL || product.code !== '25PL')
    .filter((product) => SHOW_PRODUCT_5WL85 || product.code !== VALUE['5WL85'])
    .filter((product) => SHOW_LOAN_PRODUCT || product.category !== VALUE.LOAN)
    .filter((product) => SHOW_SPUL || product.code !== VALUE.SPUL)
    .filter((product) => SHOW_PRODUCT_RPUDR || product.code !== 'RPUDR')
    .filter((product) => SHOW_PRODUCT_ICARE || product.code !== VALUE.ICARE)
    .filter((product) => SHOW_PRODUCT_IGROW || product.code !== VALUE.IGROW)
    .filter((product) => SHOW_PRODUCT_20P10 || product.code !== '20P10')
    .filter((product) => SHOW_PRODUCT_25P15 || product.code !== '25P15')
    .filter((product) => SHOW_PRODUCT_FLEXI_HEALTH || product.code !== 'FWLNP85')
    .filter((product) => SHOW_PRODUCT_25P15S || product.code !== '25P15S')
    .filter((product) => SHOW_PRODUCT_20P10S || product.code !== '20P10S')
    .filter((product) => SHOW_PRODUCT_W85P10J || product.code !== 'W85P10J')
    .filter((product) => SHOW_PRODUCT_W85P10S || product.code !== 'W85P10S')
    .filter((product) => SHOW_PRODUCT_WL88J || product.code !== 'WL88J')
    .filter((product) => SHOW_PRODUCT_WL88S || product.code !== 'WL88S')
    .filter((product) => SHOW_PRODUCT_IRETIRE_R01 || product.code !== 'R01')
    .filter((product) => SHOW_PRODUCT_IRETIRE_R05 || product.code !== 'R05')
    .filter((product) => SHOW_PRODUCT_LR05 || product.code !== 'LR05')
    .filter((product) => SHOW_PRODUCT_PLB05 || product.code !== 'PLB05')
    .filter((product) => SHOW_PRODUCT_PLB10 || product.code !== 'PLB10')
    .filter((product) => SHOW_PRODUCT_PLB12 || product.code !== 'PLB12')
    .filter((product) => SHOW_PRODUCT_PLB15 || product.code !== 'PLB15')
    .filter((product) => SHOW_PRODUCT_PERFECT_LIFE_SOLUTION || !VALUE.PERFECT_LIFE.includes(product.code))
    .filter((product) => SHOW_PRODUCT_HEALTH_TOPPING || product.code !== VALUE.HEALTH_TOPPING_CODE)
    .filter((product) => SHOW_PRODUCT_IPROTECT_10 || product.code !== '10WL85')
    .filter((product) => SHOW_PRODUCT_12PL || product.code !== '12PL')
    .filter((product) => SHOW_PRODUCT_SUKHAPABDEKDEE || product.code !== VALUE.SUKHAPABDEKDEE_CODE)
    .filter((product) => SHOW_PRODUCT_IHEALTHY_ULTRA || product.code !== VALUE.IHEALTHY_ULTRA_CODE.LIFE_LEGACY_99)
    .filter((product) => SHOW_PRODUCT_CIWLM39 || product.code !== VALUE.CIWLM39)
    .filter((product) => SHOW_PRODUCT_CIWLM50 || product.code !== VALUE.CIWLM50)
    .filter((product) => SHOW_PRODUCT_CIWLM60 || product.code !== VALUE.CIWLM60)
    .filter((product) => SHOW_PRODUCT_CIWLS39 || product.code !== VALUE.CIWLS39)
    .filter((product) => SHOW_PRODUCT_CIWLS50 || product.code !== VALUE.CIWLS50)
    .filter((product) => SHOW_PRODUCT_CIWLS65 || product.code !== VALUE.CIWLS65)
    .filter((product) => SHOW_PRODUCT_LIFEREADY || product.code !== VALUE.LIFEREADY_CODE.LIFEREADY18_UNDER)
    .filter((product) => SHOW_PRODUCT_LIFEREADY_CAMPAIGN || !VALUE.LIFEREADY_CAMPAIGN_CODE.includes(product.code))
    .filter((product) => SHOW_PRODUCT_BUMNAN_READY || !VALUE.BUMNAN_READY_CODE_GROUP.includes(product.code))
    .filter((product) => SHOW_PRODUCT_ULTIMATE_GROWTH || !VALUE.ULTIMATE_GROWTH_CODE_GROUP.includes(product.code))
    .filter((product) => SHOW_PRODUCT_LIFE_SUPER_SAVE_14_5 || product.code !== VALUE.LIFE_SUPER_SAVE_14_5_CODE)
    .filter((product) => SHOW_PRODUCT_MRTA || product.category !== VALUE.MRTA)
    .filter((product) => SHOW_PRODUCT_GLTSP || product.category !== VALUE.MRTA)
    .filter((product) => SHOW_PRODUCT_CANCERX5 || product.code !== VALUE.CANCERX5_DEFAULT_CODE)
    .filter((product) => SHOW_PRODUCT_KOOMVER_RETIRE || product.code !== VALUE.KOOMVER_RETIRE)
    .filter((product) => SHOW_PRODUCT_KOOMVER_COVER || product.code !== VALUE.KOOMVER_COVER_DEFAULT_CODE)
    .filter(
      (product) => SHOW_PRODUCT_KOOMVER_COMPENSATE || !VALUE.KOOMVER_COMPENSATE_DEFAULT_CODE.includes(product.code)
    )
    .filter((product) => SHOW_PRODUCT_KOOMVER_ROKE_RAI || !VALUE.KOOMVER_ROKE_RAI_DEFAULT_CODE.includes(product.code))
    .filter((product) => SHOW_PRODUCT_ROKE_RAI_SO_SHIELD || !VALUE.ROKE_RAI_SO_SHIELD_GROUP.includes(product.code))
    .filter((product) => SHOW_PRODUCT_ISMART_80_6 || product.code !== VALUE.ISMART_80_6)
    .filter((product) => SHOW_PRODUCT_LIFETREASURE || product.code !== VALUE.LIFETREASURE_CODE.LIFETREASURE_18)
    .filter((product) => SHOW_PRODUCT_PA || product.category !== VALUE.PA)
    .filter((product) => SHOW_PRODUCT_LIFE_ULTRA_SAVE_10_3 || product.code !== VALUE.LIFE_ULTRA_SAVE_10_3_CODE)
    .filter(
      (product) => SHOW_PRODUCT_GLOBAL_INDEX_16_6 || !Object.values(VALUE.GLOBAL_INDEX_16_6_CODE).includes(product.code)
    )
    .filter(
      (product) => SHOW_PRODUCT_INDEX_LINKED_25_5 || !Object.values(VALUE.INDEX_LINKED_25_5_CODE).includes(product.code)
    )
    .filter(
      (product) => SHOW_PRODUCT_INDEX_LINKED_15_8 || !Object.values(VALUE.INDEX_LINKED_15_8_CODE).includes(product.code)
    )
    .filter(
      (product) => SHOW_PRODUCT_KOOMVER_SOSHIELD || !Object.values(VALUE.KOOMVER_SOSHIELD_CODE).includes(product.code)
    )
    .filter((product) => SHOW_PRODUCT_LIFEREADY_SIO || !Object.values(VALUE.LIFEREADY_SIO_CODE).includes(product.code))
    .filter((product) => SHOW_PRODUCT_ISHIELD_SIO || !Object.values(VALUE.ISHIELD_SIO_CODE).includes(product.code))
    .filter((product) => SHOW_PRODUCT_12PL_SIO || product.code !== VALUE.CODE_12PL_SIO)
    .filter((product) => SHOW_PRODUCT_CI_COMBO || !Object.values(VALUE.CI_COMBO_CODE).includes(product.code))
    .filter((product) => SHOW_PRODUCT_HEALTH_COMBO || !Object.values(VALUE.HEALTH_COMBO_CODE).includes(product.code))
}

/**
 * onGetDistributorGroupsRequest
 * @param riderRepository {ReturnType<import('core/data-model/rider/repository').createRiderRepository>}
 */
export function* onGetRidersRequest(riderRepository) {
  try {
    const riders = yield call(riderRepository.listRiders)
    yield put(getRidersSuccess(riders))
  } catch (error) {
    yield put(getRidersFailed(error))
  }
}

/**
 * onGetDistributorGroupsRequest
 * @param distributorGroupRepository {ReturnType<import('core/data-model/distributor/repository').createDistributorGroupRepository>}
 */
export function* onGetDistributorGroupsRequest(distributorGroupRepository) {
  try {
    const distributorGroups = yield call(distributorGroupRepository.listDistributorGroups)
    yield put(getDistributorGroupsSuccess(distributorGroups))
  } catch (error) {
    console.error(error)
    yield put(getDistributorGroupsFailed(error))
  }
}

/**
 * onGetOccupationsRequest
 * @param {ReturnType<import('core/data/data-wrapper')._DB>} dataWrapper
 */
export function* onGetOccupationsRequest(dataWrapper) {
  try {
    const occupations = yield call(dataWrapper.getOccupations)
    yield put(getOccupationsSuccess(occupations))
  } catch (error) {
    yield put(getOccupationsFailed(error))
  }
}

/**
 * onGetOccupationFactorsRequest
 * @param {ReturnType<import('core/data/data-wrapper')._DB>} dataWrapper
 */
export function* onGetOccupationFactorsRequest(dataWrapper) {
  try {
    const occupationFactors = yield call(dataWrapper.getOccupationFactors)
    yield put(getOccupationFactorsSuccess(occupationFactors))
  } catch (error) {
    console.error(error)
    yield put(getOccupationFactorsFailed(error))
  }
}

/**
 * onGetModelFactorsRequest
 * @param {ReturnType<import('core/data/data-wrapper')._DB>} dataWrapper
 */
export function* onGetModelFactorsRequest(dataWrapper) {
  try {
    const modelFactors = yield call(dataWrapper.getModelFactors)
    yield put(getModelFactorsSuccess(modelFactors))
  } catch (error) {
    console.error(error)
    yield put(getModelFactorsFailed(error))
  }
}

/**
 * onGetViewConfiguration
 * @param basicPlanRepository {ReturnType<import('core/data-model/basic-plan/repository').createBasicPlanRepository>}
 */
export function* onGetViewConfiguration(basicPlanRepository) {
  const viewConfiguration = yield call(basicPlanRepository.getViewConfiguration)
  yield put(setViewConfiguration(viewConfiguration))
}

/**
 * onGetViewConfiguration
 * @param fnaConfigurationRepository {ReturnType<import('core/data-model/fna/repository').createFNAConfigurationRepository>}
 */
export function* onGetFNAConfiguration(fnaConfigurationRepository) {
  const fnaConfiguration = yield call(fnaConfigurationRepository.getFNAConfiguration)
  yield put(setFnaConfiguration(fnaConfiguration))
}

/**
 * checkApplicationDataReady - return isFailed
 * @param dataWrapper {ReturnType<import('core/data/data-wrapper')._DB>}
 * @param usePartnerApi {boolean}
 */
export function checkApplicationDataReady(dataWrapper, usePartnerApi) {
  return function*() {
    const products = yield select(getDisplayProducts)
    const productsStatus = yield select(getDisplayProductsStatus)
    const riders = yield select(getRiders)
    const ridersStatus = yield select(getRidersStatus)
    const occupations = yield select(getOccupations)
    const occupationsStatus = yield select(getOccupationsStatus)
    const modelFactors = yield select(getModelFactors)
    const modelFactorsStatus = yield select(getModelFactorsStatus)
    const distributorGroups = yield select(getDistributorGroups)
    const distributorGroupsStatus = yield select(getDistributorGroupsStatus)
    const canLoadLookUpData = yield apply(dataWrapper, dataWrapper.canLoadLookUpData)

    const statuses = [occupationsStatus, modelFactorsStatus, distributorGroupsStatus]

    const allItem = [occupations, modelFactors, distributorGroups]

    if (!usePartnerApi) {
      statuses.push(...[productsStatus, ridersStatus])
      allItem.push(...[products, riders])
    }

    const isAllNonEmpty = allItem.every((item) => item.length)

    return [
      statuses.includes('error') ||
        (statuses.every((status) => status === 'ready') && !isAllNonEmpty) ||
        !canLoadLookUpData,
      isAllNonEmpty,
    ]
  }
}
